import { Component, OnInit, Input } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { PartsBusinessService } from '../../../business-services/parts.service';
import { SearchAlternatePartsComponent } from './search-alternate-parts/search-alternate-parts.component';
import { SearchReplacementPartsComponent } from './search-replacement-parts/search-replacement-parts.component';
import { CookieService } from 'ngx-cookie-service';
import { CultureLocaleService } from '../../../services/culture-locale.service';

@Component({
  selector: 'app-search-parts',
  templateUrl: './search-parts.component.html',
  styleUrls: ['./search-parts.component.css']
})
export class SearchPartsComponent implements OnInit {
  popupCloseResult = false;
  closeResult = '';
  brandCode: string;
  partNumber: string = "";
  partDescription: string = "";
  makeList: BrandType[] = [];
  features: Features[] = [];
  partsList: PartsListViewModel[] = [];
  addtionalPartsList: PartsListViewModel[];
  alternativePartsList: PartsListViewModel[] = [];
  replacedPartsList: PartsListViewModel[] = [];
  selectedPart: PartsListViewModel;
  selectedPartArray: PartsListViewModel[] = [];
  isAnyActionFound:boolean = false;
  modalAlterRef: NgbModalRef;
  modalReplacementRef: NgbModalRef;
  isLocationNameVisible = true;
  @Input() fromMasterScreen:boolean = false; 
  @Input() dealerId:string = '';
  @Input() selectedPartList :any;

  constructor(
    private modalService: NgbModal,
    private partService: PartsBusinessService,
    private brandService: BrandService,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice:CookieService,
    public cultureLocaleService: CultureLocaleService
  ) { }

  ngOnInit(): void {
    this.selectedPartArray = [];
    this.GetAllMake();
    if(this.partService.searchPartNumber)
    {
      this.partNumber=this.partService.searchPartNumber;
      this.onSearchParts()
    }
    this.isLocationNameVisible = localStorage.getItem('Theme') != 'mg';
  }
  OnClose() {
    this.selectedPartArray = [];
    this.partService.selectedPartListWithAddtionalItems = [];
    this.activeModal.dismiss(false);
  }

  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  numberEmpty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
      case "0":
      case 0:
        return true;
      default:
        return false;
    }
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  isQtyPrice(event, value) {
    if (!this.cultureLocaleService.isQtyPrice(event, value)) {
      let msg = this.translate.instant("lblValidValue");
      this.toaster.error(msg)
      event.preventDefault();
    }
  }
  checkQty(e, i) {
    if (this.empty(e)) {
      e = 0;
    }
    if (this.partsList[i].availableQuantity > 0) {
      if (this.partsList[i].availableQuantity < e) {
        let errorMessage = this.translate.instant("lblQuantityValidation");
        this.toaster.error(errorMessage);
        this.partsList[i].qty = 0;
      }
      else if (e == 0) {
        let errorMessage = this.translate.instant("lblMinQuantity");
        this.toaster.error(errorMessage);
        this.partsList[i].qty = 0;
      }
      else {
        this.partsList[i].qty = Number(e.toString().replace(',', '.'));
      }
    } else {
      this.partsList[i].qty = Number(e.toString().replace(',', '.'));
    }
  }

  async onSearchParts() {
    if(localStorage.getItem("Theme") === 'mg'){
      if (this.empty(this.partDescription) && this.empty(this.partNumber)) {
        let ServiceNotFound = this.translate.instant("lblRequiredPartEntry");
        this.toaster.error(ServiceNotFound);
        return;
      }
    }else{
      if (this.empty(this.brandCode) && this.empty(this.partDescription) && this.empty(this.partNumber)) {
        let ServiceNotFound = this.translate.instant("lblRequiredPartEntry");
        this.toaster.error(ServiceNotFound);
        return;
      }
    }
    this.spinner.show();
    let model = {
      locationCode: this.partService.locationCode,
      makeCode: this.empty(this.brandCode) ? "" : this.brandCode,
      description: this.empty(this.partDescription) ? "" : this.partDescription,
      no: this.empty(this.partNumber) ? "" : this.partNumber,
      languageCode:this.cookieservice.get('userSelectedLanguage'),
      dealerId: this.dealerId
    }
    this.isAnyActionFound = false;
    await this.partService.getParts(model).then(response => {
      this.partsList = this.PartDataMapper(response);
      this.spinner.hide();
    },    _error => {
      this.spinner.hide();
    });
  }

  private PartDataMapper(service: PartsListViewModel[]) {
    let supperArray = [];
    if (service && service.length > 0) {
      service.forEach(element=>{ 
        const single = Object();
        single.id = element.id;
        single.partNumber = element.partNumber;
        single.costType = element.costType;
        single.description = element.description;
        single.unitPrice = element.unitPrice;
        single.baseUnitofMeasure = element.baseUnitofMeasure;
        single.unitCost = element.unitCost;
        single.unitPriceInclVat = element.unitPriceInclVat;
        single.makeCode = element.makeCode;
        single.quantity = element.quantity;
        single.locationCode = element.locationCode;
        single.availableQuantity = element.availableQuantity;
        single.locationName = element.locationName;
        single.hasAdditionalItems = element.hasAdditionalItems;
        single.hasAlternativeItems = element.hasAlternativeItems;
        single.hasReplacementItems = element.hasReplacementItems;
        single.itemGroupCode = element.itemGroupCode;
        single.lastDirectCost = element.lastDirectCost;
        single.listPriceLCY = element.listPriceLCY;
        single.qty = this.selectedPartArray.findIndex(f=>f.partNumber == element.partNumber) != -1? this.selectedPartArray.find(f=>f.partNumber == element.partNumber).qty : 0;
        single.isPartSelected = this.selectedPartArray.findIndex(f=>f.partNumber == element.partNumber) != -1? this.selectedPartArray.find(f=>f.partNumber == element.partNumber).isPartSelected : false;
        single.expanded = false;
        single.partLocationList = [];

        if(element.hasAdditionalItems || element.hasAlternativeItems || element.hasReplacementItems){
          this.isAnyActionFound = true;
        }
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getPartLocation(no_: any, i: number) {
    if (this.partsList[i].expanded) {
      return;
    }
    this.spinner.show();
    let model = {
      locationCode: this.partService.locationCode,
      no: no_,
      languageCode:this.cookieservice.get('userSelectedLanguage')
    }
    await this.partService.GetPartLocation(model).then(response => {
      this.partsList[i].partLocationList = response;
      this.spinner.hide();
    },_error => {
      this.spinner.hide();
    });
  }

  async getAdditionalPartLocation(no_: any, i: number) {
    if (this.addtionalPartsList[i].expanded) {
      return;
    }
    this.spinner.show();
    let model = {
      locationCode: this.partService.locationCode,
      no: no_,
      languageCode:this.cookieservice.get('userSelectedLanguage')
    }
    await this.partService.GetPartLocation(model).then(response => {
      this.addtionalPartsList[i].partLocationList = response;
      this.spinner.hide();
    },_error => {
      this.spinner.hide();
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  async GetAdditionalParts(content, parts: any) {
    this.selectedPart = parts;
    this.spinner.show();
    let model = {
      locationCode: this.partService.locationCode,
      no: parts.partNumber,
      languageCode:this.cookieservice.get('userSelectedLanguage')
    }
    await this.partService.GetAdditionalParts(model).then(response => {
      this.addtionalPartsList = response;
      this.spinner.hide();
      const modalRef = this.modalService.open(content, {
        windowClass: 'pop-wid1000 pop-hig500',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
      modalRef.result.then((_result) => { 
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          //this in intenstional
        }
      })
    },_error => {
      this.spinner.hide();
    }); 
  }

  async GetAlternativeParts(parts: any) {
    this.partService.searchPartNumber = parts.partNumber;
   
    this.modalAlterRef = this.modalService.open(SearchAlternatePartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    this.modalAlterRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.activeModal.dismiss(true);
        }
      }
    }) 
  }
 
  async GetReplacementParts( parts: any) {
    this.partService.searchPartNumber = parts.partNumber;
  
    this.modalReplacementRef = this.modalService.open(SearchReplacementPartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    this.modalReplacementRef.result.then((_result) => {
       // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.activeModal.dismiss(true);
        }
      }
    })
  }

  get checkAddedNewParts(): boolean {
    return this.selectedPartArray.some(x => x.isPartSelected);
  }

  async onSaveItems() {
    let record = this.selectedPartArray.filter(x => x.isPartSelected);
    if (record.length == 0) {
      let ServiceNotFound = this.translate.instant("lblRequiredPartSelect");
      this.toaster.error(ServiceNotFound);
      return;
    }
    this.spinner.show();
    this.partService.selectedPartListWithAddtionalItems = [];
    let model = {
      locationCode: this.partService.locationCode,
      parts: record,
      languageCode:this.cookieservice.get('userSelectedLanguage'),
      dealerId: this.dealerId
    }
    await this.partService.GetFinalPartsWithAdditional(model).then(response => {
      this.spinner.hide();
      this.partService.selectedPartListWithAddtionalItems = response;
    });
   
    this.activeModal.dismiss(true);
  }

  selectPartOnChange(event: Event,part : any){
    if(part.isPartSelected){
      this.selectedPartArray.push(part);
    }else{
      this.selectedPartArray.forEach( (item, index) => {
        if(item.partNumber === part.partNumber) this.selectedPartArray.splice(index,1);
      });
    }
  }

  removeSelectedPart(part: PartsListViewModel) {
    this.selectedPartArray = this.selectedPartArray.filter(x => x.partNumber !== part.partNumber);
    part.isPartSelected = false;
    // after a new search the row in partsList is a different object, so untick it by part number
    const row = this.partsList.find(x => x.partNumber === part.partNumber);
    if (row) row.isPartSelected = false;
  }
}


